// $(document).ready(function(){
//   let leftOffset = $('.site-navigation').offset().left;
//   console.log('导航栏左边距:', leftOffset);
// $('.site-nav__dropdown-normal .site-nav__deep-dropdown-inner').each(function() {
//   let pageWidth = $('.page-width').width();
//   let containerWidth = $(window).width();
//   let pageLeftOffset = (containerWidth - Math.min(1440, pageWidth)) / 2;
//   let paddingLeftPercentage = ((leftOffset - pageLeftOffset) / pageWidth) * 100;
//   $(this).css('padding-left', `${paddingLeftPercentage}%`);
// });
// });


 

$(document).ready(function(){
  $('.menu-drawer__menu-item-parent-title.has-child .icon-box').on('click', function(e) {
    let $parentLi = $(this).closest('.menu-drawer__menu-li');
    
    if($parentLi.hasClass('active')){ 
      // 如果已经是active状态,则移除所有状态
      $('.menu-drawer__menu-li').removeClass('active reactive');
    } else {
      // 给当前点击项的父li添加active
      $parentLi.addClass('active');
      // 给其他li添加reactive
      $('.menu-drawer__menu-li').not($parentLi).addClass('reactive').removeClass('active');
    }
  });

  $('.menu-drawer__menu-item-parent-title.nohas-child').on('click', function(e) {
    let $parentLi = $(this).closest('.menu-drawer__menu-li');
    
    if($parentLi.hasClass('active')){ 
      // 如果已经是active状态,则移除所有状态
      $('.menu-drawer__menu-li').removeClass('active reactive');
    } else {
      // 给当前点击项的父li添加active
      $parentLi.addClass('active');
      // 给其他li添加reactive
      $('.menu-drawer__menu-li').not($parentLi).addClass('reactive').removeClass('active');
    }
  });

  $('.menu-drawer__menu-item-child-title').on('click', function(e) {
    let $parentLi = $(this).closest('.menu-drawer__menu-child-li');
    
    if($parentLi.hasClass('active')){
      // 如果已经是active状态,则移除所有状态
      $('.menu-drawer__menu-child-li').removeClass('active reactive');
    } else {
      // 给当前点击项的父li添加active
      $parentLi.addClass('active');
      // 给其他li添加reactive
      $('.menu-drawer__menu-child-li').not($parentLi).addClass('reactive').removeClass('active');
    }
  });
});



function buyNowBtn(){
  let variant_id=$(`#product-main`).find("input[name='id']").val(),
     quantity=$(`#product-main`).find(".quantity__input").val();
     $('.tact-inner .right-box-buy-btn').attr("href","/cart/"+variant_id+":"+quantity);
     $(`#product-main`).find("#product-payment-button").attr("href","/cart/"+variant_id+":"+quantity);
    }
     
     
 